import type { ExploreWorkspaceSeed } from '../workspaceSeeds'

export const COACHING_DEMO_SEED: ExploreWorkspaceSeed = {
  id: 'coaching-demo',
  name: 'Apex JEE & NEET Coaching Centre',
  slug: 'coaching-demo',
  summary: 'Tuition and coaching centre with batches, evening and weekend timetables, weekly test marks, fees, and enquiries.',
  tags: ['education', 'teaching', 'coaching', 'tuition', 'jee', 'neet'],
  metrics: [
    { label: 'Learners', value: '40 enrolled' },
    { label: 'Batches', value: '4 JEE / NEET' },
  ],
  currency: 'INR',
  budgetLabel: '₹22,000 / month',
  quotaLabel: '40 / 50 seats',
  sensitiveDemo: {
    label: 'Fake coaching demo data',
    items: [
      'anand.verma@example.test',
      'All student data is synthetic (@example.test)',
    ],
  },
  members: [
    { name: 'Prof. Anand Verma', email: 'anand.verma@example.test', role: 'ADMIN' },
    { name: 'Dr. Meenakshi Sundaram', email: 'meenakshi.sundaram@example.test', role: 'EDITOR' },
    { name: 'Pradeep Kumar', email: 'pradeep.kumar@example.test', role: 'EDITOR' },
    { name: 'Dr. Shalini Joshi', email: 'shalini.joshi@example.test', role: 'EDITOR' },
    { name: 'Amit Tripathi', email: 'amit.tripathi@example.test', role: 'EDITOR' },
  ],
  elements: [],
  checklistItems: [],
  featured: true,
  heroGradient: 'SUNSET',
}
